import SignupPageDesigner from '@admin/components/signup_page_designer'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class SignupPage extends React.Component {

  static contextTypes = {
    network: PropTypes.object
  }

  static propTypes = {
    agency: PropTypes.object
  }

  render() {
    return <SignupPageDesigner { ...this._getSignupPageDesigner() } />
  }

  _getSignupPageDesigner() {
    const { agency } = this.props
    return {
      endpoint: `/api/admin/truevail/admin/agencies/${agency.id}/signup_page`,
      signup_page_id: 11
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Signup Page)',
  component: <SignupPage agency={ props.agency } />
})

export default Panel(null, mapPropsToPanel)
